import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M8 2.172 3.012 4.667l4.99 2.494 4.99-2.494L8 2.172ZM7.8.642c.133-.026.268-.026.4 0 .158.029.298.1.359.131l.016.009 6.428 3.214a.75.75 0 0 1 0 1.341L8.575 8.551l-.016.009c-.061.03-.201.102-.359.132a1.083 1.083 0 0 1-.4 0 1.352 1.352 0 0 1-.373-.14L.999 5.336a.75.75 0 0 1 0-1.341L7.427.782l.016-.009c.06-.03.2-.102.358-.132ZM.664 7.663A.75.75 0 0 1 1.67 7.33l6.332 3.166 6.331-3.166a.75.75 0 0 1 .67 1.342l-6.427 3.214-.016.008c-.061.031-.201.103-.359.132a1.082 1.082 0 0 1-.4 0c-.156-.03-.296-.1-.357-.132l-.016-.008L.999 8.67a.75.75 0 0 1-.336-1.007Zm0 3.334a.75.75 0 0 1 1.006-.336l6.332 3.166 6.331-3.166a.75.75 0 0 1 .67 1.342l-6.427 3.214-.016.008c-.061.031-.201.103-.359.133a1.082 1.082 0 0 1-.4 0 1.351 1.351 0 0 1-.357-.133l-.016-.008L1 12.003a.75.75 0 0 1-.336-1.006Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  o
];
function n(r, d) {
  return e(), l("svg", c, [...a]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
